import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzUploadModule } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-quiz',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzCollapseModule,
    CommonModule,
    NzButtonModule,
    NzIconModule,
    NzUploadModule,
    NzImageModule,
    NzInputModule,
    NzCardModule,
    NzFormModule,
    NzDatePickerModule,
    NzStepsModule
  ],
  templateUrl: './quiz.component.html',
  styleUrl: './quiz.component.scss'
})
export class QuizComponent implements OnInit {
  @Input() quizData: any;
  quizform: FormGroup;
  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) { }
  ngOnInit(): void {

    this.quizform = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      dateRange: [null, Validators.required]
    });

    if(this.quizData){
      this.quizform.patchValue(this.quizData,{ emitEvent: true });
    }
  }

  updateValidity() {
    this.quizform.markAllAsTouched();
    Object.keys(this.quizform.controls).forEach(controlName => {
      const control = this.quizform.get(controlName);
      if (control) {
        control.markAsDirty();
        control.updateValueAndValidity();  // This will re-evaluate and update the validity of the control
      }
    });
  }

}
